import { BorderGridContainer, GridBox, SpacerWrapper } from '@ahmdigital/ui';
import { ReactNode } from 'react';

import { VARIANT } from '../../../../../components/offers/tile/constants';
import HorizontalSpacingWrapper from '../../../../../components/horizontal-spacing-wrapper';
import OfferTile from '../../../../../components/offers/tile';
import type { Offer } from '../../../../../components/offers/types';

type HeaderProps = {
  beforeContent?: ReactNode;
  offer?: Offer;
  showCodeCopy?: boolean;
  showFindCover?: boolean;
  showMemberLogin?: boolean;
};

const Header = ({
  beforeContent,
  offer,
  showCodeCopy = true,
  showFindCover = true,
  showMemberLogin = false,
}: HeaderProps) => (
  <BorderGridContainer hideBorderTop>
    <GridBox padding="1rem">
      <HorizontalSpacingWrapper>
        <SpacerWrapper variant={['marginTopSpacer9', 'marginBottomSpacer9']}>
          {beforeContent}
          <OfferTile
            isBoxed={false}
            showCodeCopy={showCodeCopy}
            showFindCover={showFindCover}
            variant={VARIANT.HEADER}
            // @ts-expect-error - Automatic, Please fix when editing this file
            overrideOffers={[offer]}
            showMemberLogin={showMemberLogin}
          />
        </SpacerWrapper>
      </HorizontalSpacingWrapper>
    </GridBox>
  </BorderGridContainer>
);

export default Header;
